"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var _meterReadingDateInputHelper = require("./meterReadingDateInputHelper");
var _GermanDateHelpers = require("../../../../../utils/GermanDateHelpers");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MeterReadDateInput = _react.default.memo(function (props) {
  var newDateLabel = props.newDateLabel,
    datePlaceHolder = props.datePlaceHolder,
    lastReadingDateLabel = props.lastReadingDateLabel,
    loggedIn = props.loggedIn,
    name = props.name,
    formikProps = props.formikProps,
    _props$headerType = props.headerType,
    headerType = _props$headerType === void 0 ? 'h5' : _props$headerType;
  var values = formikProps.values,
    setFieldValue = formikProps.setFieldValue,
    getFieldMeta = formikProps.getFieldMeta,
    errors = formikProps.errors;
  if (!(values === null || values === void 0 ? void 0 : values.readingPeriod)) {
    return null;
  }
  var HeaderType = headerType;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    readingDatePicker = _useState2[0],
    setReadingDatePicker = _useState2[1];
  var readingPeriod = (0, _react.useMemo)(function () {
    return (0, _meterReadingDateInputHelper.calculateReadingPeriod)(values.readingPeriod);
  }, [values.readingPeriod]);
  var onChange = function onChange(value) {
    var newDateObj = _objectSpread(_objectSpread({}, value), {}, {
      start: (0, _moment.default)(value.text, _GermanDateHelpers.DATE_FORMAT).toDate()
    });
    var fieldName = 'readingDate';
    if (!value.text) {
      setFieldValue(fieldName, ' ');
    } else {
      setFieldValue(fieldName, newDateObj);
    }
    setReadingDatePicker(false);
  };
  var isDatePickerDisabled = (0, _react.useMemo)(function () {
    if (readingPeriod.startDate.toDateString() === readingPeriod.endDate.toDateString()) {
      return true;
    }
    return false;
  }, [readingPeriod]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ano-meter-form__input-group"
  }, /*#__PURE__*/_react.default.createElement(HeaderType, {
    className: "ano-meter-form__header ano-meter-form__header"
  }, newDateLabel), /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.DatePicker, {
    id: name,
    locale: "de",
    daysLongLocalized: _moment.default.weekdays(),
    daysShortLocalized: _moment.default.weekdaysMin(),
    monthsLocalized: _moment.default.months(),
    initialShownMonth: readingPeriod.endDate,
    name: name,
    value: values.readingDate,
    qaId: "qaId",
    label: datePlaceHolder,
    showOverlay: !isDatePickerDisabled && readingDatePicker,
    onFocus: function onFocus() {
      return setReadingDatePicker(true);
    },
    onClick: function onClick() {
      return setReadingDatePicker(true);
    },
    onBlur: function onBlur() {
      return setReadingDatePicker(false);
    },
    onChange: onChange,
    inputState: getFieldMeta('readingDate').error ? _reactSharedUiNext.InputState.ERROR : _reactSharedUiNext.InputState.VALID,
    disabled: isDatePickerDisabled,
    errorMessage: errors.readingDate,
    disabledDays: {
      before: readingPeriod.startDate,
      after: readingPeriod.endDate
    },
    minDate: readingPeriod.startDate,
    maxDate: readingPeriod.endDate
  }), loggedIn ? /*#__PURE__*/_react.default.createElement("strong", {
    className: loggedIn ? 'loggedin-meter-form__last-values' : 'ano-meter-form__last-values'
  }, "\n            ".concat(lastReadingDateLabel, "\n            ").concat((0, _meterReadingDateInputHelper.prepareDateForDisplay)(values.registers), "\n            ")) : null));
});
var _default = exports.default = MeterReadDateInput;